import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=1ffbb74d&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=1ffbb74d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffbb74d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffbb74d')) {
      api.createRecord('1ffbb74d', component.options)
    } else {
      api.reload('1ffbb74d', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=1ffbb74d&scoped=true&", function () {
      api.rerender('1ffbb74d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Cw9q0kjUAE7z/JS/comp/DocBox.vue"
export default component.exports